module.exports = __webpack_public_path__ + "static/sperandii-1abe61bfe12e56e9a8650ef8a87b45c7.jpg";